module.exports = __webpack_public_path__ + "bigcry.b21968e0.png";